<template>
  <div>
    <div class="form-group">
      <template v-if="changeKey">
        <label>{{ $tc('Keys', 1) }}</label>
        <input
          v-model="model.key"
          type="text"
          class="form-control"
          required
          @change="updated"
        >
      </template>
      <template v-else>
        {{ $tc('Keys', 1) }}: <b>{{ model.key }}</b>
      </template>
    </div>
    <div class="form-group">
      <label>{{ $t('Name') }}</label>
      <input
        v-model="model.name"
        type="text"
        required
        minlength="1"
        maxlength="255"
        class="form-control"
        @change="updated"
      >
    </div>
    <div class="form-group">
      <label>{{ $t('Description') }}</label>
      <textarea
        v-model="model.description"
        class="form-control textarea"
        @change="updated"
      />
    </div>
    <div class="form-group">
      <label>{{ $t('Default value') }}</label>
      <textarea
        v-model="model.default"
        class="form-control textarea"
        @change="updated"
      />
    </div>
    <div class="form-group">
      <input
        v-model="model.required"
        type="checkbox"
        @change="updated"
      >
      <label>{{ $t('Required') }}?</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMarketplaceFieldForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    changeKey: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value: {
      handler(v) {
        this.model = v;
      },
      deep: true,
    },
  },
  methods: {
    updated() {
      this.$emit('input', this.model);
    },
  },
};
</script>
